'use es6';

import { Component } from 'react';
import { connect } from 'react-redux';
import { getCategoryId, getFullCategoryName } from 'ContentEditorUI/redux/selectors/contentReadOnlyDataSelectors';
import { getContentName } from 'ContentEditorUI/redux/selectors/baseContentModelSelectors';
import { getLastSaveDate } from 'ContentEditorUI/redux/selectors/editingInfoSelectors';
import { getIsAtCorrectUrlForContentType, getBaseEditorUrlForCurrentType } from 'ContentEditorUI/redux/selectors/urlSelectors';
import { getAppStatus } from 'ContentEditorUI/redux/selectors/appStatusSelectors';
import { captureMessage } from 'ContentEditorUI/lib/exceptions';
import ContentEditorComponent from 'ContentEditorUI/components/ContentEditorComponent';
// ContentEditorContainer, a top-level component which owns:
//  - Rendering the top-most DOM for the app
//  - Access checking (scopes/roles/gates)
//  - Some initialization that depends on the content schema/model already have been fetched
//  - Post-load whole page loading spinner (based on appStatus)
import { jsx as _jsx } from "react/jsx-runtime";
const mapStateToProps = state => {
  return {
    appStatus: getAppStatus(state),
    baseEditorUrlForCurrentType: getBaseEditorUrlForCurrentType(state),
    contentCategoryId: getCategoryId(state),
    contentName: getContentName(state),
    fullCategoryName: getFullCategoryName(state),
    isAtCorrectUrlForContentType: getIsAtCorrectUrlForContentType(state),
    lastSavedDate: getLastSaveDate(state)
  };
};

/**
 * @param {Object} props
 * @param {string} props.appStatus (required)
 * @param {string} [props.baseEditorUrlForCurrentType] (optional)
 * @param {React.ReactNode} [props.children] (optional)
 * @param {number} props.contentCategoryId (required)
 * @param {string} props.contentName (required)
 * @param {Function} [props.fetchCustomFontsByThemePath] (optional)
 * @param {string} props.fullCategoryName (required)
 * @param {boolean} props.isAtCorrectUrlForContentType (required)
 * @param {string} [props.themePath] (optional)
 */
class ContentEditorContainer extends Component {
  componentDidMount() {
    this.redirectToAnotherAppIfNecessary();
  }

  // Ensure we're in the correct app for the correct content type
  redirectToAnotherAppIfNecessary() {
    const {
      contentCategoryId,
      baseEditorUrlForCurrentType,
      isAtCorrectUrlForContentType
    } = this.props;
    if (isAtCorrectUrlForContentType === false) {
      captureMessage(`Redirected user to correct editor for categoryId=${contentCategoryId}`);
      window.location = baseEditorUrlForCurrentType;
    }
  }
  render() {
    return /*#__PURE__*/_jsx(ContentEditorComponent, Object.assign({}, this.props));
  }
}
export default connect(mapStateToProps)(ContentEditorContainer);